// banner

import bannerAlexandra from "@/assets/images/homepage/projects/alexandra-grey/banner-alexandra-grey.svg";
import bannerBab from "@/assets/images/homepage/projects/bab/banner-bab.svg";
import bannerBruno from "@/assets/images/homepage/projects/bruno-calonne/banner-bruno-calonne.svg";
import bannerSharmila from "@/assets/images/homepage/projects/sharmila/banner-sharmila.svg";
import bannerHitako from "@/assets/images/homepage/projects/hitako/banner-hitako.png";
import bannerWorkio from "@/assets/images/homepage/projects/workio/banner-workio.png";

// mockup desktop

import mockupDesktopAlexandra from "@/assets/images/homepage/projects/alexandra-grey/mockup-desktop-alexandra-grey.png";
import mockupDesktopBab from "@/assets/images/homepage/projects/bab/mockup-desktop-bab.png";
import mockupDesktopBruno from "@/assets/images/homepage/projects/bruno-calonne/mockup-desktop-bruno-calonne.png";
import mockupDesktopSharmila from "@/assets/images/homepage/projects/sharmila/mockup-desktop-sharmila.png";
import mockupDesktopHitako from "@/assets/images/homepage/projects/hitako/mockup-desktop-hitako.png";
import mockupDesktopWorkio from "@/assets/images/homepage/projects/workio/mockup-desktop-workio.png";

// mockup phone

import mockupPhoneAlexandra from "@/assets/images/homepage/projects/alexandra-grey/mockup-phone-alexandra-grey.png";
import mockupPhoneBab from "@/assets/images/homepage/projects/bab/mockup-phone-bab.png";
import mockupPhoneBruno from "@/assets/images/homepage/projects/bruno-calonne/mockup-phone-bruno-calonne.png";
import mockupPhoneSharmila from "@/assets/images/homepage/projects/sharmila/mockup-phone-sharmila.png";
import mockupPhoneHitako from "@/assets/images/homepage/projects/hitako/mockup-phone-hitako.png";
import mockupPhoneWorkio from "@/assets/images/homepage/projects/workio/mockup-phone-workio.png";

// project logo

import projectLogoAlexandra from "@/assets/images/homepage/projects/alexandra-grey/project-logo-alexandra-grey.svg";
import projectLogoBab from "@/assets/images/homepage/projects/bab/project-logo-bab.svg";
import projectLogoSharmila from "@/assets/images/homepage/projects/sharmila/project-logo-sharmila.svg";
import projectLogoHitako from "@/assets/images/homepage/projects/hitako/project-logo-hitako.png";

export interface Project {
  id: string;
  name: string;
  url: string;
  bannerImage?: string;
  mockupDesktopImage?: string;
  mockupPhoneImage?: string;
  projectLogo?: string;
  translationKey?: string;
  showInProjectsSections?: boolean;
  showInScrollingBanner?: boolean;
  showInCarousselSection?: boolean;
}

export const projects: Project[] = [
  {
    id: "workio",
    name: "Workio",
    mockupDesktopImage: mockupDesktopWorkio.src,
    mockupPhoneImage: mockupPhoneWorkio.src,
    bannerImage: bannerWorkio.src,
    url: "https://www.myworkio.com/",
    showInScrollingBanner: true,
    showInProjectsSections: false,
    showInCarousselSection: true,
  },
  {
    id: "hitako",
    name: "Hitako",
    mockupDesktopImage: mockupDesktopHitako.src,
    mockupPhoneImage: mockupPhoneHitako.src,
    bannerImage: bannerHitako.src,
    projectLogo: projectLogoHitako.src,
    url: "https://www.hitako.com/",
    translationKey: "hitako",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "alexandra",
    name: "Alexandra",
    bannerImage: bannerAlexandra.src,
    mockupDesktopImage: mockupDesktopAlexandra.src,
    mockupPhoneImage: mockupPhoneAlexandra.src,
    projectLogo: projectLogoAlexandra.src,
    url: "https://www.alexandra-grey.fr/",
    translationKey: "alexandra",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "bab",
    name: "BAB",
    bannerImage: bannerBab.src,
    mockupDesktopImage: mockupDesktopBab.src,
    mockupPhoneImage: mockupPhoneBab.src,
    projectLogo: projectLogoBab.src,
    url: "https://www.bab-lefrenchkebab.fr/",
    translationKey: "bab",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "sharmila",
    name: "Sharmila",
    bannerImage: bannerSharmila.src,
    mockupDesktopImage: mockupDesktopSharmila.src,
    mockupPhoneImage: mockupPhoneSharmila.src,
    projectLogo: projectLogoSharmila.src,
    url: "https://www.sharmila-osteopathe.com/",
    translationKey: "sharmila",
    showInScrollingBanner: true,
    showInCarousselSection: true,
    showInProjectsSections: true,
  },
  {
    id: "bruno-calonne",
    name: "Bruno Calonne",
    bannerImage: bannerBruno.src,
    mockupDesktopImage: mockupDesktopBruno.src,
    mockupPhoneImage: mockupPhoneBruno.src,
    url: "https://www.artisan-clotures-portails.com/",
    showInScrollingBanner: true,
    showInCarousselSection: false,
  },
  {
    id: "workio-2",
    name: "Workio",
    mockupDesktopImage: mockupDesktopWorkio.src,
    mockupPhoneImage: mockupPhoneWorkio.src,
    bannerImage: bannerWorkio.src,
    url: "https://www.myworkio.com/",
    showInScrollingBanner: true,
    showInProjectsSections: false,
    showInCarousselSection: true,
  },
  {
    id: "hitako-2",
    name: "Hitako",
    mockupDesktopImage: mockupDesktopHitako.src,
    mockupPhoneImage: mockupPhoneHitako.src,
    bannerImage: bannerHitako.src,
    projectLogo: projectLogoHitako.src,
    url: "https://www.hitako.com/",
    translationKey: "hitako",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "alexandra-2",
    name: "Alexandra",
    bannerImage: bannerAlexandra.src,
    mockupDesktopImage: mockupDesktopAlexandra.src,
    mockupPhoneImage: mockupPhoneAlexandra.src,
    projectLogo: projectLogoAlexandra.src,
    url: "https://www.alexandra-grey.fr/",
    translationKey: "alexandra",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "bab-2",
    name: "BAB",
    bannerImage: bannerBab.src,
    mockupDesktopImage: mockupDesktopBab.src,
    mockupPhoneImage: mockupPhoneBab.src,
    projectLogo: projectLogoBab.src,
    url: "https://www.bab-lefrenchkebab.fr/",
    translationKey: "bab",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "sharmila-2",
    name: "Sharmila",
    bannerImage: bannerSharmila.src,
    mockupDesktopImage: mockupDesktopSharmila.src,
    mockupPhoneImage: mockupPhoneSharmila.src,
    projectLogo: projectLogoSharmila.src,
    url: "https://www.sharmila-osteopathe.com/",
    translationKey: "sharmila",
    showInScrollingBanner: true,
    showInCarousselSection: true,
    showInProjectsSections: true,
  },
  {
    id: "bruno-calonne-2",
    name: "Bruno Calonne",
    bannerImage: bannerBruno.src,
    mockupDesktopImage: mockupDesktopBruno.src,
    mockupPhoneImage: mockupPhoneBruno.src,
    url: "https://www.artisan-clotures-portails.com/",
    showInScrollingBanner: true,
    showInCarousselSection: false,
  },
  // Vague 3
  {
    id: "workio-3",
    name: "Workio",
    mockupDesktopImage: mockupDesktopWorkio.src,
    mockupPhoneImage: mockupPhoneWorkio.src,
    bannerImage: bannerWorkio.src,
    url: "https://www.myworkio.com/",
    showInScrollingBanner: true,
    showInProjectsSections: false,
    showInCarousselSection: true,
  },
  {
    id: "hitako-3",
    name: "Hitako",
    mockupDesktopImage: mockupDesktopHitako.src,
    mockupPhoneImage: mockupPhoneHitako.src,
    bannerImage: bannerHitako.src,
    projectLogo: projectLogoHitako.src,
    url: "https://www.hitako.com/",
    translationKey: "hitako",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "alexandra-3",
    name: "Alexandra",
    bannerImage: bannerAlexandra.src,
    mockupDesktopImage: mockupDesktopAlexandra.src,
    mockupPhoneImage: mockupPhoneAlexandra.src,
    projectLogo: projectLogoAlexandra.src,
    url: "https://www.alexandra-grey.fr/",
    translationKey: "alexandra",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "bab-3",
    name: "BAB",
    bannerImage: bannerBab.src,
    mockupDesktopImage: mockupDesktopBab.src,
    mockupPhoneImage: mockupPhoneBab.src,
    projectLogo: projectLogoBab.src,
    url: "https://www.bab-lefrenchkebab.fr/",
    translationKey: "bab",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "sharmila-3",
    name: "Sharmila",
    bannerImage: bannerSharmila.src,
    mockupDesktopImage: mockupDesktopSharmila.src,
    mockupPhoneImage: mockupPhoneSharmila.src,
    projectLogo: projectLogoSharmila.src,
    url: "https://www.sharmila-osteopathe.com/",
    translationKey: "sharmila",
    showInScrollingBanner: true,
    showInCarousselSection: true,
    showInProjectsSections: true,
  },
  {
    id: "bruno-calonne-3",
    name: "Bruno Calonne",
    bannerImage: bannerBruno.src,
    mockupDesktopImage: mockupDesktopBruno.src,
    mockupPhoneImage: mockupPhoneBruno.src,
    url: "https://www.artisan-clotures-portails.com/",
    showInScrollingBanner: true,
    showInCarousselSection: false,
  },
  // Vague 4
  {
    id: "workio-4",
    name: "Workio",
    mockupDesktopImage: mockupDesktopWorkio.src,
    mockupPhoneImage: mockupPhoneWorkio.src,
    bannerImage: bannerWorkio.src,
    url: "https://www.myworkio.com/",
    showInScrollingBanner: true,
    showInProjectsSections: false,
    showInCarousselSection: true,
  },
  {
    id: "hitako-4",
    name: "Hitako",
    mockupDesktopImage: mockupDesktopHitako.src,
    mockupPhoneImage: mockupPhoneHitako.src,
    bannerImage: bannerHitako.src,
    projectLogo: projectLogoHitako.src,
    url: "https://www.hitako.com/",
    translationKey: "hitako",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "alexandra-4",
    name: "Alexandra",
    bannerImage: bannerAlexandra.src,
    mockupDesktopImage: mockupDesktopAlexandra.src,
    mockupPhoneImage: mockupPhoneAlexandra.src,
    projectLogo: projectLogoAlexandra.src,
    url: "https://www.alexandra-grey.fr/",
    translationKey: "alexandra",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "bab-4",
    name: "BAB",
    bannerImage: bannerBab.src,
    mockupDesktopImage: mockupDesktopBab.src,
    mockupPhoneImage: mockupPhoneBab.src,
    projectLogo: projectLogoBab.src,
    url: "https://www.bab-lefrenchkebab.fr/",
    translationKey: "bab",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "sharmila-4",
    name: "Sharmila",
    bannerImage: bannerSharmila.src,
    mockupDesktopImage: mockupDesktopSharmila.src,
    mockupPhoneImage: mockupPhoneSharmila.src,
    projectLogo: projectLogoSharmila.src,
    url: "https://www.sharmila-osteopathe.com/",
    translationKey: "sharmila",
    showInScrollingBanner: true,
    showInCarousselSection: true,
    showInProjectsSections: true,
  },
  {
    id: "bruno-calonne-4",
    name: "Bruno Calonne",
    bannerImage: bannerBruno.src,
    mockupDesktopImage: mockupDesktopBruno.src,
    mockupPhoneImage: mockupPhoneBruno.src,
    url: "https://www.artisan-clotures-portails.com/",
    showInScrollingBanner: true,
    showInCarousselSection: false,
  },
  // Vague 5
  {
    id: "workio-5",
    name: "Workio",
    mockupDesktopImage: mockupDesktopWorkio.src,
    mockupPhoneImage: mockupPhoneWorkio.src,
    bannerImage: bannerWorkio.src,
    url: "https://www.myworkio.com/",
    showInScrollingBanner: true,
    showInProjectsSections: false,
    showInCarousselSection: true,
  },
  {
    id: "hitako-5",
    name: "Hitako",
    mockupDesktopImage: mockupDesktopHitako.src,
    mockupPhoneImage: mockupPhoneHitako.src,
    bannerImage: bannerHitako.src,
    projectLogo: projectLogoHitako.src,
    url: "https://www.hitako.com/",
    translationKey: "hitako",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "alexandra-5",
    name: "Alexandra",
    bannerImage: bannerAlexandra.src,
    mockupDesktopImage: mockupDesktopAlexandra.src,
    mockupPhoneImage: mockupPhoneAlexandra.src,
    projectLogo: projectLogoAlexandra.src,
    url: "https://www.alexandra-grey.fr/",
    translationKey: "alexandra",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "bab-5",
    name: "BAB",
    bannerImage: bannerBab.src,
    mockupDesktopImage: mockupDesktopBab.src,
    mockupPhoneImage: mockupPhoneBab.src,
    projectLogo: projectLogoBab.src,
    url: "https://www.bab-lefrenchkebab.fr/",
    translationKey: "bab",
    showInProjectsSections: true,
    showInScrollingBanner: true,
    showInCarousselSection: true,
  },
  {
    id: "sharmila-5",
    name: "Sharmila",
    bannerImage: bannerSharmila.src,
    mockupDesktopImage: mockupDesktopSharmila.src,
    mockupPhoneImage: mockupPhoneSharmila.src,
    projectLogo: projectLogoSharmila.src,
    url: "https://www.sharmila-osteopathe.com/",
    translationKey: "sharmila",
    showInScrollingBanner: true,
    showInCarousselSection: true,
    showInProjectsSections: true,
  },
  {
    id: "bruno-calonne-5",
    name: "Bruno Calonne",
    bannerImage: bannerBruno.src,
    mockupDesktopImage: mockupDesktopBruno.src,
    mockupPhoneImage: mockupPhoneBruno.src,
    url: "https://www.artisan-clotures-portails.com/",
    showInScrollingBanner: true,
    showInCarousselSection: false,
  },
];

// Fonctions utilitaires pour filtrer les projets
export const getProjectsForSection = (
  section: "projects" | "scrollingBanner" | "carousel",
) => {
  switch (section) {
    case "projects":
      return projects
        .filter((project) => project.showInProjectsSections === true)
        .filter(
          (project, index, self) =>
            index === self.findIndex((p) => p.name === project.name),
        );
    case "scrollingBanner":
      return projects.filter(
        (project) =>
          project.showInScrollingBanner === true && project.bannerImage,
      );
    case "carousel":
      return projects.filter(
        (project) =>
          project.mockupDesktopImage &&
          project.mockupPhoneImage &&
          project.showInCarousselSection === true,
      );
    default:
      return projects;
  }
};
